const pageNameKey = "machineStructurePanel";

export const machineStructurePanelEn = {
  [pageNameKey]: {
    subtitle: "Twin Structure",
    warningNoEmptyStructureName: "Structure name cannot be empty",
    lastReceivedAt: "Last received: ",
    errorFetchingLastUpdatedAt: "Failed to retrieve the last updated time.",
    errorRefreshingTwinStructure: "Failed to refresh Twin Structure.",
    noTimestampAvailable: "Timestamp is not available",
    refreshButtonText: "Refresh",
  },
};

export const machineStructurePanelPtBr = {
  [pageNameKey]: {
    subtitle: "Estrutura da Máquina",
    warningNoEmptyStructureName: "O nome da estrutura não pode estar vazio",
    lastReceivedAt: "Última recebida: ",
    errorFetchingLastUpdatedAt: "Falha ao recuperar a última atualização.",
    errorRefreshingTwinStructure: "Falha ao atualizar a estrutura da máquina.",
    noTimestampAvailable: "Timestamp não disponível",
    refreshButtonText: "Atualizar",
  },
};

export const machineStructurePanelDe = {
  [pageNameKey]: {
    subtitle: "Zwillingsstruktur",
    warningNoEmptyStructureName: "Strukturname darf nicht leer sein",
    lastReceivedAt: "Zuletzt empfangen: ",
    errorFetchingLastUpdatedAt:
      "Fehler beim Abrufen der letzten Aktualisierung.",
    errorRefreshingTwinStructure:
      "Fehler beim Aktualisieren der Zwillingsstruktur.",
    noTimestampAvailable: "Zeitstempel nicht verfügbar",
    refreshButtonText: "Aktualisieren",
  },
};

export const machineStructurePanelZhHans = {
  [pageNameKey]: {
    subtitle: "双胞结构",
    warningNoEmptyStructureName: "结构名称不能为空",
    lastReceivedAt: "最后接收时间: ",
    errorFetchingLastUpdatedAt: "获取最后更新时间失败。",
    errorRefreshingTwinStructure: "刷新双胞结构失败。",
    noTimestampAvailable: "时间戳不可用",
    refreshButtonText: "刷新",
  },
};

export const machineStructurePanelIt = {
  [pageNameKey]: {
    subtitle: "Struttura gemella",
    warningNoEmptyStructureName: "Il nome della struttura non può essere vuoto",
    lastReceivedAt: "Ultimo ricevuto: ",
    errorFetchingLastUpdatedAt:
      "Impossibile recuperare l'ultima data di aggiornamento.",
    errorRefreshingTwinStructure:
      "Impossibile aggiornare la struttura gemella.",
    noTimestampAvailable: "Timestamp non disponibile",
    refreshButtonText: "Aggiorna",
  },
};

export const machineStructurePanelEs = {
  [pageNameKey]: {
    subtitle: "Estructura gemela",
    warningNoEmptyStructureName:
      "El nombre de la estructura no puede estar vacío",
    lastReceivedAt: "Último recibido: ",
    errorFetchingLastUpdatedAt: "Error al recuperar la última actualización.",
    errorRefreshingTwinStructure: "Error al actualizar la estructura gemela.",
    noTimestampAvailable: "Timestamp no disponible",
    refreshButtonText: "Actualizar",
  },
};

export const machineStructurePanelNl = {
  [pageNameKey]: {
    errorFetchingLastUpdatedAt: "Fout bij het ophalen van de laatste update.",
    errorRefreshingTwinStructure:
      "Fout bij het vernieuwen van de tweelingstructuur.",
    lastReceivedAt: "Laatst ontvangen: ",
    noTimestampAvailable: "Timestamp niet beschikbaar",
    refreshButtonText: "Vernieuwen",
    subtitle: "Zwillingsstructuur",
    warningNoEmptyStructureName: "Structuurnaam mag niet leeg zijn",
  },
};

export const machineStructurePanelTr = {
  [pageNameKey]: {
    errorFetchingLastUpdatedAt: "Son güncellenme saati alınamadı.",
    errorRefreshingTwinStructure: "İkiz Yapı yenilenemedi.",
    lastReceivedAt: "Son alınan:",
    noTimestampAvailable: "Zaman damgası kullanılamıyor",
    refreshButtonText: "Yenile",
    subtitle: "İkiz Yapı",
    warningNoEmptyStructureName: "Yapı adı boş olamaz",
  },
};
